module.exports = __webpack_public_path__ + "141d4a85/img/google.68f3823e.svg";